import makeHead from 'components/Table/Head' 

const GradesHead = makeHead([
  { id: 'date', align: 'left', disablePadding: false},
  { id: 'type', align: 'left', disablePadding: false},
  { id: 'name', align: 'left', disablePadding: false},
  { id: 'term', align: 'left', disablePadding: false},
  { id: 'points', align: 'left', disablePadding: false},
],({styles}) => ({...styles}))

export {GradesHead as default}
